/** Modulo Layouts de e-mail (200) — contracts/enums.yaml */
export const LAYOUT_EMAIL_ACAO = {
  CRIAR: 2001,
  ATUALIZAR: 2002,
  REMOVER: 2003,
} as const;

export const LAYOUT_EMAIL_ACOES_MODULO = [
  LAYOUT_EMAIL_ACAO.CRIAR,
  LAYOUT_EMAIL_ACAO.ATUALIZAR,
  LAYOUT_EMAIL_ACAO.REMOVER,
] as const;
